import RegisterForm from 'components/Forms/RegisterForm/RegisterForm'

import { Login, MainPage, StatementPage, TasksPage } from 'pages'

import ChatPageContainer from 'pages/ChatPage/ChatPageContainer'

import StatementInfo from 'pages/StatementPage/components/StatementTable/StatementInfo/StatementInfo'

import TaskItemInfo from 'pages/TasksPage/components/TaskItem/TaskItemInfo/TaskItemInfo'

import TaskTree from 'hooks/TaskTree/TaskTree'

import QuizForm from 'components/Forms/QuizForm/QuizForm'
import StructureForm from 'components/Forms/StructureForm/StructureForm'

import CalendarPage from 'pages/CalendarPage/CalendarPage'
import AllStatisticPage from 'pages/StatisticPage/AllStatisticPage'
import StatisticPage from 'pages/StatisticPage/StatisticPage'
import StructureInfo from 'pages/StructurePage/components/StructureInfo'
import StructurePage from 'pages/StructurePage/StructurePage'

import { ArchivePage, ArchiveDetail } from 'pages/ArchivePage'

import Europass from 'pages/ProfilePage/Europass/Europass'
import FinalEuropass from 'pages/ProfilePage/Europass/FinalEuropass'
import PersonalCard from 'pages/ProfilePage/PersonalCard/PersonalCard'


import EuropassEn from 'pages/ProfilePage/Europass/EuropassEn/EuropassEn'
import FinalEuropassEn from 'pages/ProfilePage/Europass/EuropassEn/FinalEuropassEn'
import EuropassKy from 'pages/ProfilePage/Europass/EuropassKy/EuropassKy'
import FinalEuropassKy from 'pages/ProfilePage/Europass/EuropassKy/FinalEuropassKy'



import AdminPage from 'pages/AdminPage/AdminPage'

import ReportCard from "pages/ReportCard/ReportCard";
import NotesPage from "pages/NotesPage/NotesPage";

import TestPage from "pages/TestPage/TestPage";
import TestContent from "pages/TestPage/components/components/TestContent";
import PartWorkUsed from 'pages/TestPage/components/usedcomponents/PartWorkUsed'
import PartWorkUsedAllUser from 'pages/TestPage/components/usedcomponents/PartWorkUsedAllUser'
import SurveyPage from "pages/SurveyPage/SurveyPage";
import SurveyContent from "pages/SurveyPage/components/components/SurveyContent";
import PartSurveyUsed from 'pages/SurveyPage/components/usedcomponents/PartSurveyUsed'
import PartSurveyUsedAllUser from 'pages/SurveyPage/components/usedcomponents/PartSurveyUsedAllUser'

import AccountingPage from 'pages/AccountingPage/AccountingPage'
import AccountingDataPage from 'pages/AccountingPage/AccountingDataPage'

export const routes = [
  { path: '/', component: <Login /> },
 
  { path: '/home/', component: <MainPage /> },

  

    
  { path: '/tasks/', component: <TasksPage /> },

  { path: '/task/', component: <TaskItemInfo isSubTask={false} /> },
  
 { path: '/subtask/', component: <TaskItemInfo isSubTask={true} /> },
    
 { path: '/statements/', component: <StatementPage /> },
 
  { path: '/statement/', component: <StatementInfo /> },
  { path: '/chats/', component: <ChatPageContainer /> },
  { path: '/chats/:id/', component: <ChatPageContainer /> },
  { path: '/register_person/', component: <RegisterForm /> },
  { path: '/statistic/', component: <StatisticPage /> },
  { path: '/all-statistic/', component: <AllStatisticPage /> },
  { path: '/task-tree/', component: <TaskTree /> },
  { path: '/structure/', component: <StructurePage /> },
  { path: '/structure-sheme/:id/', component: <StructureInfo /> },
  { path: '/add-structure/', component: <StructureForm /> },
  { path: '/answer-quiz/', component: <QuizForm /> },
  { path: '/calendar/', component: <CalendarPage /> },
  { path: '/report-card/', component: <ReportCard /> },

  { path: '/notes/', component: <NotesPage /> },


  { path: '/personalcard/', component: <PersonalCard /> },
  { path: '/europass/', component: <Europass /> },
  { path: '/finaleuro/', component: <FinalEuropass /> },
  { path: '/europassen/', component: <EuropassEn /> },
  { path: '/finaleuropassen/', component: <FinalEuropassEn /> },
  { path: '/europassky/', component: <EuropassKy /> },
  { path: '/finaleuropassky/', component: <FinalEuropassKy /> },
  { path: '/admin_organizations/', component: <AdminPage /> },
  
  { path: '/test/:id', component: <PartWorkUsedAllUser /> },

  { path: '/tests/', component: <TestPage /> },
  { path: '/worktest/', component: <TestContent /> },
  { path: '/useworktest/', component: <PartWorkUsed /> },
  { path: '/surveys/', component: <SurveyPage /> },
  { path: '/survey/', component: <SurveyContent /> },
  { path: '/survey/:id', component: <PartSurveyUsedAllUser /> },
  { path: '/usesurvey/', component: <PartSurveyUsed /> },
  
  { path: '/accounting/', component: <AccountingPage /> },
  { path: '/accounting-info/', component: <AccountingDataPage /> },

  { path: '/archive/', component: <ArchivePage /> },
  { path: '/archive/:archiveType/', component: <ArchiveDetail /> },
]
